// extracted by mini-css-extract-plugin
export default {"statusHeadline":"StatusExplainer_statusHeadline__Um-V+","statusExplainer":"StatusExplainer_statusExplainer__UOPah"};